import { render, staticRenderFns } from "./UserGroupDetail.vue?vue&type=template&id=ec354dc2&scoped=true"
import script from "./UserGroupDetail.vue?vue&type=script&lang=js"
export * from "./UserGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./UserGroupDetail.vue?vue&type=style&index=0&id=ec354dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec354dc2",
  null
  
)

export default component.exports